import React from 'react';

/**
 * Toolbar with tool buttons, zoom controls, toggles.
 */
export default function Toolbar({
  tool,
  onSetTool,
  specialMode,
  onSpecialMode,
  onCancelSpecial,
  showDimensions,
  onToggleDimensions,
  showOverlay,
  onToggleOverlay,
  canUndo,
  canRedo,
  onUndo,
  onRedo,
  onExportPNG,
  onZoomIn,
  onZoomOut,
  onFitView,
  selectedEsq,
  selectedWall,
  onRotateEsq,
  onDeleteSelected,
  projectName,
}) {
  const btnBase = {
    padding: '6px 10px',
    border: '1px solid #E5E7EB',
    borderRadius: 6,
    cursor: 'pointer',
    fontSize: 12,
    fontFamily: 'Inter, sans-serif',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    background: '#FFFFFF',
    color: '#374151',
    transition: 'all 0.15s',
  };

  const btnActive = {
    ...btnBase,
    background: '#1E3A5F',
    color: '#FFFFFF',
    borderColor: '#1E3A5F',
  };

  const btnSpecial = { // eslint-disable-line no-unused-vars
    ...btnBase,
    background: specialMode ? '#F97316' : '#FFFFFF',
    color: specialMode ? '#FFFFFF' : '#374151',
    borderColor: specialMode ? '#F97316' : '#E5E7EB',
  };

  const sep = <div style={{ width: 1, height: 24, background: '#E5E7EB', margin: '0 4px' }} />;

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 4,
      padding: '8px 14px',
      borderBottom: '1px solid #E5E7EB',
      background: '#FFFFFF',
      flexWrap: 'wrap',
    }}>
      {/* Project name */}
      <div style={{
        fontWeight: 700,
        fontSize: 14,
        color: '#1E3A5F',
        fontFamily: 'Inter, sans-serif',
        marginRight: 8,
      }}>
        QCO Plan
      </div>

      {projectName && (
        <div style={{
          padding: '2px 8px',
          background: '#F3F4F6',
          borderRadius: 4,
          fontSize: 11,
          color: '#6B7280',
          fontFamily: 'Inter, sans-serif',
          marginRight: 8,
        }}>
          {projectName}
        </div>
      )}

      {sep}

      {/* Tool buttons */}
      <button
        style={tool === 'select' ? btnActive : btnBase}
        onClick={() => onSetTool('select')}
        title="Selecionar (V)"
      >
        ↖ Selecionar
      </button>
      <button
        style={tool === 'pan' ? btnActive : btnBase}
        onClick={() => onSetTool('pan')}
        title="Mover (H)"
      >
        ✋ Mover
      </button>
      <button
        style={tool === 'edit' ? btnActive : btnBase}
        onClick={() => onSetTool(tool === 'edit' ? 'select' : 'edit')}
        title="Editar (E)"
      >
        ✏️ Editar
      </button>

      {sep}

      {/* Special modes */}
      <button
        style={specialMode === 'addwall' ? { ...btnBase, background: '#F97316', color: '#fff', borderColor: '#F97316' } : btnBase}
        onClick={() => {
          if (specialMode === 'addwall') onCancelSpecial();
          else onSpecialMode('addwall');
        }}
        title="Adicionar Parede (W)"
      >
        🧱 +Parede
      </button>
      <button
        style={specialMode === 'addroom' ? { ...btnBase, background: '#F97316', color: '#fff', borderColor: '#F97316' } : btnBase}
        onClick={() => {
          if (specialMode === 'addroom') onCancelSpecial();
          else onSpecialMode('addroom');
        }}
        title="Adicionar Cômodo"
      >
        ⬜ +Cômodo
      </button>

      {sep}

      {/* Undo/Redo */}
      <button
        style={{ ...btnBase, opacity: canUndo ? 1 : 0.4 }}
        onClick={onUndo}
        disabled={!canUndo}
        title="Desfazer (Ctrl+Z)"
      >
        ↩
      </button>
      <button
        style={{ ...btnBase, opacity: canRedo ? 1 : 0.4 }}
        onClick={onRedo}
        disabled={!canRedo}
        title="Refazer (Ctrl+Shift+Z)"
      >
        ↪
      </button>

      {/* Context-sensitive buttons */}
      {selectedEsq && (
        <button
          style={btnBase}
          onClick={() => onRotateEsq && onRotateEsq(90)}
          title="Rotacionar (R)"
        >
          ↻
        </button>
      )}
      {(selectedEsq || selectedWall) && (
        <button
          style={{ ...btnBase, color: '#EF4444', borderColor: '#FCA5A5' }}
          onClick={onDeleteSelected}
          title="Excluir (Del)"
        >
          🗑
        </button>
      )}

      {sep}

      {/* Zoom */}
      <button style={btnBase} onClick={onZoomIn} title="Zoom In (+)">+</button>
      <button style={btnBase} onClick={onZoomOut} title="Zoom Out (-)">−</button>
      <button style={btnBase} onClick={onFitView} title="Fit to View">⊡</button>

      {sep}

      {/* Toggles */}
      <button
        style={showOverlay ? btnActive : btnBase}
        onClick={onToggleOverlay}
        title="Overlay planta original"
      >
        🖼
      </button>
      <button
        style={showDimensions ? btnActive : btnBase}
        onClick={onToggleDimensions}
        title="Cotas"
      >
        📏
      </button>
      <button
        style={btnBase}
        onClick={onExportPNG}
        title="Exportar PNG"
      >
        📷
      </button>
    </div>
  );
}